import { invisiblyApi } from 'src/redux/api/invisibly-api';
import { InvisiblyApiResponse } from 'src/services/api/api-response.types';
import { APITagType } from 'src/redux/api/invisibly-api.types';

export interface ReportingApiEntitlementDataset {
  dataset: string;
  entitled: boolean;
  grantable: boolean;
}

export interface ReportingApiEntitlementSummary {
  client_id: string;
  client_title: string;
  datasets: ReportingApiEntitlementDataset[];
}

const reportingApiEntitlementsEndpoints = invisiblyApi.injectEndpoints({
  endpoints: (builder) => ({
    getReportingApiEntitlements: builder.query<ReportingApiEntitlementSummary | null, string>({
      query: (clientId) => ({
        method: 'get',
        url: 'b2b/operations/reporting-api-entitlements',
        params: { client_id: clientId },
      }),
      transformResponse(response: InvisiblyApiResponse<ReportingApiEntitlementSummary>) {
        return response.item ?? null;
      },
      providesTags: (_result, _error, clientId) => [
        { id: clientId, type: APITagType.ReportingApiKeys },
      ],
    }),
    grantReportingApiEntitlement: builder.mutation<
    ReportingApiEntitlementSummary,
    { ext_client_id: string; dataset: string }
    >({
      query: (data) => ({
        method: 'post',
        url: 'b2b/operations/reporting-api-entitlements/grant',
        data,
      }),
      transformResponse(response: InvisiblyApiResponse<ReportingApiEntitlementSummary>) {
        return response.item;
      },
      invalidatesTags: (_result, _error, arg) => [
        { id: arg.ext_client_id, type: APITagType.ReportingApiKeys },
      ],
    }),
    revokeReportingApiEntitlement: builder.mutation<
    ReportingApiEntitlementSummary,
    { ext_client_id: string; dataset: string }
    >({
      query: (data) => ({
        method: 'post',
        url: 'b2b/operations/reporting-api-entitlements/revoke',
        data,
      }),
      transformResponse(response: InvisiblyApiResponse<ReportingApiEntitlementSummary>) {
        return response.item;
      },
      invalidatesTags: (_result, _error, arg) => [
        { id: arg.ext_client_id, type: APITagType.ReportingApiKeys },
      ],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetReportingApiEntitlementsQuery,
  useGrantReportingApiEntitlementMutation,
  useRevokeReportingApiEntitlementMutation,
} = reportingApiEntitlementsEndpoints;
